import axios from "axios";
export default {
  namespaced: true,
  state: {
    summaries: [],
    loading: false,
  },
  getters: {
    summaries(state) {
      return state.summaries;
    },
    loading(state) {
      return state.loading;
    },
  },
  mutations: {
    SET_SUMMARIES(state, summaries) {
      state.summaries = summaries;
    },
    SET_LOADING(state, val) {
      state.loading = val;
    },
  },
  actions: {
    async get_quotation_summaries({ commit }, params) {
      commit("SET_LOADING", true);
      try {
        let response = await axios.get("/quotations/summary", {
          params: params || {},
        });
        commit("SET_SUMMARIES", response.data);
      } finally {
        commit("SET_LOADING", false);
      }
    },
  },
};
